import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EChallan from "./component";
import { setGaSource } from "../../shared/ga-source/actions";
import { fetchChallanLandingPageData, fetchOrderData, fetchRegNumberList } from "./actions";
import { withRouter } from "react-router";

const mapStateToProps = ({
    gaSource: { source },
    eChallan: { cmsContent, isSSR, regNumberList, recentTransaction, pageType },
    user: { isLoggedIn, secureToken }
}) => ({
    source,
    cmsContent,
    isSSR,
    regNumberList,
    recentTransaction,
    isLoggedIn,
    secureToken,
    pageType
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setGaSourceConnect: setGaSource,
    fetchChallanLandingPageDataConnect: fetchChallanLandingPageData,
    fetchRegNumberListConnect: fetchRegNumberList,
    fetchOrderDataConnect: fetchOrderData
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EChallan));
